import Evt from './utils/event'

const gameBus = new Evt()

export default gameBus
